import React from "react";
import { FaChevronDown } from "react-icons/fa";
import "./InfoStudy.css";
import "../study.css";

const InfoStudy = ({ show, onClose, study }) => {
  if (!study) return null;

  return (
    <div
      className={`offcanvas offcanvas-end ${show ? "show" : ""}`}
      style={{
        visibility: show ? "visible" : "hidden",
        backgroundColor: "white",
        zIndex: 1050,
      }}
      tabIndex="-1"
    >
      {/* Header */}
      <div className="offcanvas-header border-bottom">
        <h5 className="offcanvas-title">Informations de l'étude</h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => onClose(false)}
        ></button>
      </div>

      {/* Body */}
      <div className="offcanvas-body d-flex flex-column">
        <div className="flex-grow-1 overflow-auto pe-1">
          {/* --- Nom --- */}
          <div className="mb-3">
            <div className="study-field py-1 px-4 w-100">
              <span className="study-field-label">Nom de l'étude</span>
              <p className="m-0">{study.name || "Non spécifié"}</p>
            </div>
          </div>

          {/* --- Contact --- */}
          <div className="mb-3">
            <div className="study-field py-1 px-4 w-100">
              <span className="study-field-label">Contact</span>
              <p className="m-0">{study.contact || "Non spécifié"}</p>
            </div>
          </div>

          {/* --- Résumé --- */}
          <div className="mb-3">
            <a
              className="collapsable-btn p-3 d-flex justify-content-between align-items-center"
              data-bs-toggle="collapse"
              href="#collapseAbstract"
              role="button"
              aria-expanded="true"
              aria-controls="collapseAbstract"
            >
              <span>Résumé de l'étude</span>
              <FaChevronDown />
            </a>
            <div className="collapse show py-2 px-3" id="collapseAbstract">
              <div
                className="study-content border rounded p-3 bg-light"
                dangerouslySetInnerHTML={{
                  __html: study.abstract || "Aucun résumé disponible.",
                }}
              ></div>
            </div>
          </div>

          {/* --- Protocole --- */}
          <div className="mb-3">
            <a
              className="collapsable-btn p-3 d-flex justify-content-between align-items-center"
              data-bs-toggle="collapse"
              href="#collapseProtocol"
              role="button"
              aria-expanded="true"
              aria-controls="collapseProtocol"
            >
              <span>Protocole</span>
              <FaChevronDown />
            </a>
            <div className="collapse show py-2 px-3" id="collapseProtocol">
              <div
                className="study-content border rounded p-3 bg-light"
                dangerouslySetInnerHTML={{
                  __html: study.protocol || "Aucun protocole disponible.",
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoStudy;
